import { Bar, mixins } from 'vue-chartjs';
import chartMixin from './chartMixin';
export default {
  name: 'NiotaClassicChartsBar',
  extends: Bar,
  mixins: [mixins.reactiveProp, chartMixin],
  props: {
    chartDataT: {
      type: Object,
      default: function () {
        return {};
      }
    },
    multiChartDataT: {
      type: Object,
      default: function () {
        return {};
      }
    },
    options: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  watch: {
    options: {
      handler: function () {
        this.updateBarChart();
      },
      deep: true
    },
    multiChartDataT: {
      handler: function () {
        this.updateBarChart();
      },
      deep: true
    },
    chartDataT: {
      handler: function () {
        // this.updateBarChart();
      },
      deep: true
    }
  },
  mounted() {
    this.updateBarChart();
  },
  methods: {
    updateBarChart() {
      const mappedChartData = this.mapChartData();
      const chartOptions = this.chartOptions(this.options);
      this.renderChart({
        labels: mappedChartData.labels || [],
        datasets: mappedChartData.datasets || []
      }, chartOptions);
    },
    mapChartData() {
      const multiChartData = this.multiChartDataT;
      const chartData = this.chartDataT;
      if (multiChartData.individual) {
        return {
          datasets: multiChartData.individual.map((dataset, index) => {
            const color = multiChartData.common.color ? this.shadeColor(10 - index * 30, multiChartData.common.color || '#17bc00') : dataset.color;
            return {
              label: dataset.label,
              pointBackgroundColor: color,
              borderColor: dataset.disableHoverColor ? color : undefined,
              backgroundColor: color || 'transparent',
              hoverBackgroundColor: dataset.disableHoverColor ? color : undefined,
              hoverBorderColor: dataset.disableHoverColor ? color : undefined,
              pointRadius: 1,
              borderWidth: 2,
              data: dataset.data
            };
          }),
          labels: multiChartData.common.labels
        };
      } else {
        const color = this.shadeColor(10, chartData.color || '#17bc00');
        return {
          labels: chartData.dataLabels,
          datasets: [{
            label: chartData.label,
            pointBackgroundColor: color,
            borderColor: color,
            backgroundColor: color || 'transparent',
            pointRadius: 1,
            borderWidth: 2,
            data: chartData.data
          }]
        };
      }
    }
  }
};